const isFunc = (prop) => prop && typeof prop === 'function'

export default isFunc
